<template>
	<AnalyticsSectionPreviewCard
		linkOnTop
		title="Total runs"
		linkText="Show breakdown"
		class="card-container width-100 pb-12"
		:toRouteName="ANALYTICS_USAGE_PER_DAY_ROUTE_NAME"
	>
		<Col class="width-100 height-100 flex-centerize">
			<AnalyticsTotalRunsBar class="graph-wrapper flex-centerize px-2" />
		</Col>
	</AnalyticsSectionPreviewCard>
</template>

<script>
import { ANALYTICS_USAGE_PER_DAY_ROUTE_NAME } from '@/router/router.const.js';
import AnalyticsTotalRunsBar from '@/components/Analytics/Charts/AnalyticsTotalRunsBar.vue';
import AnalyticsSectionPreviewCard from '@/components/Analytics/Cards/AnalyticsSectionPreviewCard.vue';

export default {
	name: 'AnalyticsTotalRunsGraphCard',
	components: { AnalyticsTotalRunsBar, AnalyticsSectionPreviewCard },
	data() {
		return { ANALYTICS_USAGE_PER_DAY_ROUTE_NAME };
	},
};
</script>
<style scoped lang="scss">
.card-container {
	max-height: 450px;
}
.graph-wrapper {
	max-width: 780px;
}
</style>
